import { DataBean } from "../DataBean";

export class ExportProject extends DataBean {



    public async exportProjectData(idProject: any, tableName: any, documentsTable: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProjectData_Number_String_String", [idProject, tableName, documentsTable]);
    }

}